import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  reinscripcionesUsuariosPeticion,
  descargarCSVExampleReinscripcionPeticion,
  inscripcionesUsuariosPeticion,
  descargarCSVExampleInscripcionPeticion,
} from 'repositories/inscripciones_repository';

interface InscripcionState {
  loading: boolean;
  error: string | null;
}

const initialState: InscripcionState = {
  loading: false,
  error: null,
};

export const reinscripcionesUsuarios = createAsyncThunk(
  'inscripcion/reinscripciones',
  async (data: FormData, { rejectWithValue }) => {
    try {
      return await reinscripcionesUsuariosPeticion(data);
    } catch {
      return rejectWithValue('Error al procesar reinscripciones');
    }
  },
);

export const descargarCSVExampleReinscripcion = createAsyncThunk(
  'inscripcion/descargarCSVReinscripcion',
  async (_, { rejectWithValue }) => {
    try {
      return await descargarCSVExampleReinscripcionPeticion();
    } catch {
      return rejectWithValue('Error al descargar CSV de reinscripción');
    }
  },
);

export const inscripcionesUsuarios = createAsyncThunk(
  'inscripcion/inscripciones',
  async (data: FormData, { rejectWithValue }) => {
    try {
      return await inscripcionesUsuariosPeticion(data);
    } catch {
      return rejectWithValue('Error al procesar inscripciones');
    }
  },
);

export const descargarCSVExampleInscripcion = createAsyncThunk(
  'inscripcion/descargarCSVInscripcion',
  async (_, { rejectWithValue }) => {
    try {
      return await descargarCSVExampleInscripcionPeticion();
    } catch {
      return rejectWithValue('Error al descargar CSV de inscripción');
    }
  },
);

export const inscripcionSlice = createSlice({
  name: 'inscripcion',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(reinscripcionesUsuarios.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(reinscripcionesUsuarios.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(reinscripcionesUsuarios.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(inscripcionesUsuarios.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(inscripcionesUsuarios.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(inscripcionesUsuarios.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default inscripcionSlice.reducer;
